<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout wrap>
      <v-flex
        xs12
        body-1
      >
        <h3>Important or Required Public Notices</h3>
        <material-download-card
          title=" Consumer Confidence Report 2024 English"
          url="./img/2024 CCR-English.pdf"
          sub-icon="mdi-calendar"
          sub-text="Download Consumer Confidence Report 2024 English "
        />
        <material-download-card
          title="Consumer Confidence Report 2024 - Espanol"
          url="./img/2024 CCR-Spanish.pdf"
          sub-icon="mdi-calendar"
          sub-text="Download  Consumer Confidence Report 2024 - Espanol"
        />
        <material-download-card
          title=" Consumer Confidence Report 2023"
          url="./img/2023 CCR English.pdf"
          sub-icon="mdi-calendar"
          sub-text="Download Consumer Confidence Report 2023 English "
        />
        <material-download-card
          title=" Consumer Confidence Report 2023 - Espanol"
          url="./img/2023 CCR Spanish.pdf"
          sub-icon="mdi-calendar"
          sub-text="Download  Consumer Confidence Report 2023 - Espanol"
        />
        <material-download-card
          title=" Boil Water Cancellation Notice 2023-01-11"
          url="./img/1900936 AGUA J MUTUAL WATER BWN CANCELLATION 01.11.2023 - English.pdf"
          sub-icon="mdi-calendar"
          sub-text="Download  Boil Water Cancellation Notice 2023-01-11 English"
        />
        <material-download-card
          title=" Boil Water Cancellation Notice 2023-01-11 - Espanol"
          url="./img/1900936 AGUA J MUTUAL WATER BWN CANCELLATION 01.11.2023 spanish.pdf"
          sub-icon="mdi-calendar"
          sub-text="Download  Boil Water Cancellation Notice 2023-01-11 - Espanol"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style>
  p b {
    font-size: 14px;
  }
</style>
